import React, {useContext} from 'react'
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import NoticeIntegerInput from "../../components/inputs/NoticeIntegerInput";
import NoticeNumericInput from "../../components/inputs/NoticeNumericInput";
import NoticeYesNoInput from "../../components/inputs/NoticeYesNoInput";


function OffersNotDivided(
    {
        id,
        formikProps,
    }) {

    const gId = (name) => id + "." + name;
    const tenderCompletedWithContract = getObjectValue("form.tenderCompletionData.notDivided.tenderCompletionType", formikProps.values, null) === "zawarcieUmowy";
    const {getDict} = useContext(FormTranslationContext)

    return (<>

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfOffers")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfVariantOffers")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfAdditionalOffers")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfOffersMMSP")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfOffersEOG")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfOffersOutsideEOG")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfRejectedOffers")}
            required={tenderCompletedWithContract}
        />

        <NoticeIntegerInput
            formikProps={formikProps}
            id={gId("numberOfExtremelyLowOffers")}
            required={tenderCompletedWithContract}
        />

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("lowestPriceOfferValue")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("lowestPriceOfferValueCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required
        />

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("highestPriceOfferValue")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("highestPriceOfferValueCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required
        />

        <NoticeNumericInput
            formikProps={formikProps}
            id={gId("priceOfBestOfferContractorValue")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            id={gId("priceOfBestOfferContractorCurrency")}
            formikProps={formikProps}
            items={getDict("SL.MO.043")}
            required
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("variantOffer")}
            required={tenderCompletedWithContract}
        />

        <NoticeYesNoInput
            formikProps={formikProps}
            id={gId("auctionPlanned")}
            required={tenderCompletedWithContract}
        />

        <NoticeGlossaryInput
            formikProps={formikProps}
            id={gId("bestOfferCriteria")}
            items={getDict("SL.MO.030")}
            multiple
        />

    </>)
}

OffersNotDivided.propTypes = {};

export default OffersNotDivided;
